export const SUPERADMINMANAGEREGION = "SUPERADMINMANAGEREGION";
export const DEKAFLEXIREGION = "DEKAFLEXIREGION";
export const DEKABOXREGION = "DEKABOXREGION";
export const MANAGEZONE = "MANAGEZONE";
